import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPrintTool = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_141_18318)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M37.3916 1.10547H10.675C7.33159 1.10547 4.61133 3.81996 4.61133 7.15622V41.0021C4.61133 44.3383 7.33159 47.0528 10.675 47.0528H37.3916C40.735 47.0528 43.4552 44.3383 43.4552 41.0021V7.15622C43.4552 3.81996 40.735 1.10547 37.3916 1.10547ZM40.1421 39.7479V40.9133C40.1421 42.1408 39.1452 43.1357 37.915 43.1357H10.1498C8.9196 43.1357 7.92265 42.1408 7.92265 40.9133V10.0874C7.92265 8.85989 8.9196 7.86505 10.1498 7.86505H37.915C39.1452 7.86505 40.1421 8.85989 40.1421 10.0874V39.7479Z",
				fill: "#AC9B9C"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M25.3223 13.8321V16.7739C25.3223 18.0015 24.3253 18.9963 23.0951 18.9963H11.9791C10.7489 18.9963 9.75195 18.0015 9.75195 16.7739V12.5974C9.75195 11.3698 10.7489 10.375 11.9791 10.375H23.0951C24.3253 10.375 25.3223 11.3698 25.3223 12.5974V13.8338V13.8321Z",
				fill: "#D0C0C1"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M35.4069 14.2826C35.9481 14.2826 36.3879 14.7214 36.3879 15.2615V16.7733C36.3879 17.3133 35.9481 17.7521 35.4069 17.7521H29.4537C28.9125 17.7521 28.4728 17.3133 28.4728 16.7733V15.2615C28.4728 14.7214 28.9125 14.2826 29.4537 14.2826H35.4069ZM35.4069 13.0391H29.4537C28.2235 13.0391 27.2266 14.0339 27.2266 15.2615V16.7733C27.2266 18.0008 28.2235 18.9957 29.4537 18.9957H35.4069C36.6371 18.9957 37.6341 18.0008 37.6341 16.7733V15.2615C37.6341 14.0339 36.6371 13.0391 35.4069 13.0391Z",
				fill: "#D0C0C1"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M25.3223 24.875V27.8169C25.3223 29.0445 24.3253 30.0393 23.0951 30.0393H11.9791C10.7489 30.0393 9.75195 29.0445 9.75195 27.8169V23.6404C9.75195 22.4128 10.7489 21.418 11.9791 21.418H23.0951C24.3253 21.418 25.3223 22.4128 25.3223 23.6404V24.8768V24.875Z",
				fill: "#D0C0C1"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M35.4069 25.3256C35.9481 25.3256 36.3879 25.7644 36.3879 26.3044V27.8162C36.3879 28.3563 35.9481 28.7951 35.4069 28.7951H29.4537C28.9125 28.7951 28.4728 28.3563 28.4728 27.8162V26.3044C28.4728 25.7644 28.9125 25.3256 29.4537 25.3256H35.4069ZM35.4069 24.082H29.4537C28.2235 24.082 27.2266 25.0769 27.2266 26.3044V27.8162C27.2266 29.0438 28.2235 30.0386 29.4537 30.0386H35.4069C36.6371 30.0386 37.6341 29.0438 37.6341 27.8162V26.3044C37.6341 25.0769 36.6371 24.082 35.4069 24.082Z",
				fill: "#D0C0C1"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M35.4059 33.5248C35.9471 33.5248 36.3869 33.9636 36.3869 34.5036V38.8578C36.3869 39.3979 35.9471 39.8367 35.4059 39.8367H11.981C11.4398 39.8367 11.0001 39.3979 11.0001 38.8578V34.5036C11.0001 33.9636 11.4398 33.5248 11.981 33.5248H35.4059ZM35.4059 32.2812H11.981C10.7509 32.2812 9.75391 33.2761 9.75391 34.5036V38.8578C9.75391 40.0854 10.7509 41.0802 11.981 41.0802H35.4059C36.6361 41.0802 37.6331 40.0854 37.6331 38.8578V34.5036C37.6331 33.2761 36.6361 32.2812 35.4059 32.2812Z",
				fill: "#D0C0C1"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_141_18318",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 38.8421,
			height: 45.9474,
			fill: "white",
			transform: "translate(4.61133 1.10547)"
		})
	}) })]
});
export default SvgPrintTool;
